angular.module('octopusApp.projects')
    .controller('VariableEditorScopeController', function ($scope, $q, $uibModalInstance, $location, busy, octopusRepository, selectedScopeValues, availableScopeValues, isFilter, canScopeToTenantTags, canScopeToSteps) {
    var vm = this;
    var isLoading = vm.isLoading = busy.create();

    vm.close = $uibModalInstance.close;
    vm.save = save;

    vm.isFilter = isFilter;
    vm.availableScopeValues =  availableScopeValues;
    vm.selectedScopeValues = cloneScope(selectedScopeValues);
    vm.canScopeToTenantTags = canScopeToTenantTags;
    vm.canScopeToSteps = canScopeToSteps;

    function save() {
        $uibModalInstance.close({
            selectedScopeValues: vm.selectedScopeValues
        });
    }

    function cloneScope(originalScopeValues){
        var copyScopes = _.clone(originalScopeValues);
        _.map(copyScopes, function(a) { return _.clone(a); });
        return copyScopes;
    }
});


//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/directives/variable_editor_scope.js
// module id = 4453822587768609
// module chunks = 1